import React, { Component, PropTypes } from 'react';
import classNames from 'classnames';
import Select from 'react-select';
import TimeConstant from 'constants/Time';
import ShallowCompare from 'react-addons-shallow-compare';

import 'react-select/dist/react-select.min.css';
import './SelectControl.scss';

const LABEL_SIZE = ['small', 'normal'];
const TYPE = ['default', 'time'];

class SelectControl extends Component {

    static propTypes = {
        label: PropTypes.string.isRequired,
        labelSize: PropTypes.oneOf(LABEL_SIZE),
        subLabel: PropTypes.string,
        value: PropTypes.any,
        options: PropTypes.array,
        name: PropTypes.string,
        className: PropTypes.string,
        disabled: PropTypes.bool,
        onChange: PropTypes.func,
        selectType: PropTypes.oneOf(TYPE),
    };

    static defaultProps = {
        label: '',
        labelSize: 'normal',
        subLabel: '',
        disabled: false,
        name: '',
        selectType: 'default',
    }

    shouldComponentUpdate(nextProps, nextState) {
        return ShallowCompare(this, nextProps, nextState);
    }

    _onChange = (newValue) => {
      if (this.props.onChange) this.props.onChange(null, [newValue]);
    };

    render() {
        var {className, onChange, ...props} = this.props;
        var selectClass = classNames([
          'SelectControl',
          className,
          'SelectControl--' + props.selectType
        ]);

        var options;
        if (!props.options && props.selectType === 'time') {
          options = TimeConstant.Hours;
        } else {
          options = props.options;
        }
    
        let star = ''
        if (props.required) {
            star = (<span className="SelectControl-label-required">*</span>)
        }

        var label = null;
        if (props.label) {
            label = (
              <label className={ classNames([
                                    'SelectControl-label',
                                    'SelectControl-label--' + props.labelSize
                                ]) }
                     htmlFor={props.id}>
                  { props.label } { star }
              </label>
            );
        }

        return (
            <div className={ selectClass }>
                { label }
                <Select
                      {...props}
                      value={this.props.value || options[0].value}
                      name={this.props.name}
                      options={options}
                      searchable={false}
                      clearable={false}
                      disabled={this.props.disabled}
                      onChange={ this._onChange }
                />
            </div>
        );
    }

}

export default SelectControl;



// WEBPACK FOOTER //
// ./client/components/SelectControl/SelectControl.js